<template>
  <v-container fluid>
    <v-dialog v-model="dialog" >
      <v-card>
        <v-container  fluid grid-list-lg class="mx-0 pa-0" style="overflow: hidden !important;">
          <v-layout class="" row wrap>
            <v-flex xs12>
              <type-ahead @closed="dialog = false;" @documentType="documentTypeChange" @documentFilter="documentFilterChage" permissions="true"></type-ahead>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <v-flex xs12>
      <v-card v-if="deny == true">
        <v-container bg fill-height grid-list-md >
          <v-layout row wrap align-center>
            <v-flex xs12 text-xs-center>
              <h1 style="color: red">Error</h1>
              <p>Missing required list of roles</p>
              <hr/>
              <p>Must be admin and this page cannot be accessed directly</p>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
      <v-card v-else-if="cleanup == true">
        <v-container bg fill-height grid-list-md >
          <v-layout row wrap align-top>
            <v-flex xs12>
              <h2 >Comparing with database...</h2>
            </v-flex>
            <v-flex xs5>
              <h4 >Wordpress Roles</h4>
              <hr/>
              <p v-for="item in $membershipRoles">{{item}}</p>
            </v-flex>
            <v-flex xs2>
            </v-flex>
            <v-flex xs5>
              <h4 >CRM Roles</h4>
              <hr/>
              <center v-if="membershipFromDatabase.length == 0">
                <br/>
                <v-progress-circular
                    :size="100"
                    :width="10"
                    color="#2196f3"
                    indeterminate
                ></v-progress-circular>
              </center>
              <p v-for="item in membershipFromDatabase"
                 v-bind:class="{ 'red--text': item.unmatched }">{{item.rolename}}</p>
            </v-flex>
            <v-flex xs12 text-xs-center v-if="!working && deleteLog.length == 0">
              <hr/>
              <br/>
              <p>Highlighted roles seem to no longer exist in wordpress. Delete them from the CRM database?</p>
              <v-btn class="red darken-3" small dark @click="working = true; deleteMissing()">Yes</v-btn>
              <v-btn class="green darken-3" small dark @click="cleanup = false">No</v-btn>
            </v-flex>
            <v-flex xs12 v-if="!working && deleteLog.length > 0" style="background: #ebebeb;">
              <hr/>
              <br/>
              <p v-for="item in deleteLog">{{item}}</p>
            </v-flex>
            <v-flex xs12 text-xs-center v-if="!working && deleteLog.length > 0">
              <br/>
              <v-btn class="green darken-3" small dark @click="cleanup = false">Continue</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
      <v-card v-else>
        <v-card-title>
          <span class="title">Membership Access Control</span>
          <v-spacer></v-spacer>
          <v-btn class="green darken-3" v-if="!working" fab small dark @click.native="savePermissions">
            <v-icon>save</v-icon>
          </v-btn>
          <v-progress-circular v-else
              :size="30"
              :width="2"
              color="#2196f3"
              indeterminate
          ></v-progress-circular>
        </v-card-title>
        <v-flex>
          <v-expansion-panel  v-model="selectedGroup" popout>
            <v-expansion-panel-content
                v-for="item in membershipGroups"
                :key="item._id"
            >
              <template v-slot:header>
                <v-flex xs11>
                  <h2 style="text-transform: capitalize;" v-if="selectedGroup != null && membershipGroups[selectedGroup].rolename == item.rolename">
                    <center>{{item.rolename}}</center>
                  </h2>
                  <p v-else>{{item.rolename}}</p>
                </v-flex>
                <v-flex xs1>
                  <v-icon color="yellow darken-1" v-if="item.unsaved == true">check_circle_outline</v-icon>
                  <v-icon color="green darken-1" v-else>check_circle</v-icon>
                </v-flex>
              </template>
              <v-card>
                <v-container bg fill-height grid-list-md >
                  <v-layout row wrap align-center>
                    <v-flex xs12>
                      <v-card v-for="item in selectedGroupOptions">
                        <v-layout row wrap align-center>
                          <v-flex xs1>
                            <v-btn icon ripple  small @click="removePermission(item)">
                              <v-icon color="red lighten-1">delete</v-icon>
                            </v-btn>
                          </v-flex>
                          <v-flex xs9>
                            <h4>{{item.DocType}} -- {{item.DocFilter}}</h4>
                          </v-flex>
                        </v-layout>
                      </v-card>

                      <v-card>
                        <v-layout row wrap >
                          <v-flex xs12>
                            <v-spacer></v-spacer>
                          </v-flex>
                          <v-flex text-xs-center>
                            <v-btn @click="addPermission(); dialog=true" small>
                              Add Permitted Query
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-card>
    </v-flex>
   </v-container>
</template>
<script>
/* globals Store */

import TypeAhead from "../components/TypeAhead";

export default {
  components: {
    TypeAhead
  },
  data () {
    return {
      cleanup: false,
      selectedGroup: null,
      deleteLog: [],
      working: true,
      dialog: false,
      search: null,
      deny: false,
      membershipGroups: [],
      membershipFromDatabase: []
    }
  },
  methods: {
    savePermissions() {
      this.working = true;
      this.membershipGroups.forEach((item)=>{
        if(item.unsaved == true) {
          if(item.id != undefined) { // update existing
            console.log('updating', item)
            return this.$updateMembershipGroup(item.id,
                {
                  'rolename':item.rolename,
                  'access': item.access
                }
            ).then((result)=>{
              item.unsaved = false
              this.working = false
            })
          } else { // create new
            console.log('creating new', item)
            return this.$createMembershipGroup({
              'rolename':item.rolename,
              'access': item.access
            }).then((result)=>{
              console.log('result was', result)
              item.id = result.id
              item.unsaved = false
              this.working = false
            })
          }
        }

      })
    },
    removePermission(item) {
      var options = this.membershipGroups[this.selectedGroup].access
      for(var i =0; i < options.length; i++) {
        if(options[i] == item) {
          options.splice(i, 1)
          this.membershipGroups[this.selectedGroup].unsaved = true
        }
      }
      console.log('otpions is', options)
      this.$set(this.membershipGroups[this.selectedGroup], 'access', options)
    },
    addPermission() {
      console.log('WEEEEEEEEEEEE',this.membershipGroups[this.selectedGroup])
      this.membershipGroups[this.selectedGroup].unsaved = true
      let defaultOptions = {
        DocFilter: 'all',
        DocType: 'all'
      }
      if (this.membershipGroups[this.selectedGroup].access == undefined || this.membershipGroups[this.selectedGroup].access == null)
        this.membershipGroups[this.selectedGroup].access = [defaultOptions]
      else
        this.membershipGroups[this.selectedGroup].access.push(defaultOptions)
    },
    documentFilterChage(value) {
      if(value == null)
        value = 'all'

      if(this.dialog)
        this.membershipGroups[this.selectedGroup].access[this.selectedGroupOptions.length - 1].DocFilter = value
      console.log('documentFilterChage', this.membershipGroups)
    },
    documentTypeChange(value){
      if(this.dialog)
        this.membershipGroups[this.selectedGroup].access[this.selectedGroupOptions.length - 1].DocType = value
      console.log('documentTypeChange', this.membershipGroups)
    },
    removeOption(){

    },
    deleteMissing() {
      this.membershipFromDatabase.forEach((item)=>{
        if(item.unmatched) {
          this.$deleteMembershipGroup(item.id).then((result)=>{
            this.deleteLog.push('Deleted: ' + item.id + ' -- ' + item.rolename)
           }).catch((error)=>{
            this.deleteLog.push('Error Deleting: ' + item.id + ' -- ' + item.rolename + '  (' + error + ')')
          })
        }
      })
      setTimeout(()=>{
        this.working = false
      }, 1000)
    },
    loadData(){
      var toReturn = []
      this.$services.membership.find({
      }).then((result) => {

        console.log('membership fetch result', result)
        result.forEach((role) => {
          if(this.$membershipRoles.find(document=>document == role.rolename) == undefined) {
            console.log('role to delete is', role)
            role.unmatched = true
            this.cleanup = true
            //this.$deleteMembershipGroup(role.id)
          }

          this.membershipFromDatabase.push(role)
        })

        setTimeout(()=>{
          this.working = false
        }, 1000)

        this.$membershipRoles.forEach((role) => {
          console.log('role is', role)
          let itemObj = {
            'rolename':role,
            'access':[],
            'unsaved':false
          }
          let dbResult = result.find(item=>item.rolename == role)
          if(dbResult != undefined) {
            itemObj.access = JSON.parse(dbResult.access)
            itemObj.id = dbResult.id
          }

          toReturn.push(itemObj)

        })
        console.log('returning', toReturn)
        this.membershipGroups = toReturn

      })
    }
  },
  computed: {
    selectedGroupOptions(){
      if(this.selectedGroup != null) {
        return this.membershipGroups[this.selectedGroup].access
      }

      return []
    }
  },
  created () {
  },
  mounted () {

    this.$nextTick(() => {
      if(this.$membershipRoles.length > 0) {
        this.loadData()
      } else {
        this.deny = true;
      }

    })
  }
}
</script>


